import React from 'react';
import BackButton from './BackButton';

const Account = () => {


  return (
    <div className="container mt-5">
    <BackButton />
      <iframe
        src="/Identity/Account/Manage"
        title="Account Iframe"
        style={{ width: '100%', height: '80vh' }}
      />

    </div>
  );
};

export default Account;
